import { MedicalCareType } from '../../../../../core/enum/documentation/medical-care-type';
import { MedicalDocumentationType } from '../../../../../core/enum/documentation/medical-documentation-type';
import { VisitType } from '../../../../../core/enum/documentation/visit-type.enum';

export interface MedicalDocumentationBodyDto {
    customerId: number | string;
    medicalCareType?: MedicalCareType;
    accidentDate?: string;
    pastMedicalConditions?: boolean;
    pastMedicalConditionsDescription?: string;
    type: MedicalDocumentationType;
}

export interface GeneraliMedicalDocumentationBodyDto extends MedicalDocumentationBodyDto {
    type: MedicalDocumentationType.GENERALI;
    visitId: number;
    portfolioPaperId: number;
    portfolioPaperVersion: number;
    medicalOperationNeeded?: string;
    medicalHistory?: string;
    diagnosisCode?: string;
    diagnosisDescription?: string;
    visitDateTime?: string;
    visitType?: VisitType;
}

export interface CofusMedicalDocumentationBodyDto extends MedicalDocumentationBodyDto {
    type: MedicalDocumentationType.COFUS;
    id?: string;
    maskedDocumentIds?: string[];
    descriptionOfOccurrence: string;
    customerComment: string;
}

export class MedicalDocumentBodyDto {
    fileName: string | undefined;
    contentType: string | undefined;
    base64EncodedBytes: string | undefined;
}

export type MedicalDocumentationBodyDtoUnion = GeneraliMedicalDocumentationBodyDto | CofusMedicalDocumentationBodyDto;
